import { PublicationStatusEnum } from '@ztechapps/common.contract'

// Each `color` is a CSS custom property defined in `libs/blog/webui/src/BlogStatus.scss`.
// It resolves only in a browser that has loaded that stylesheet; elsewhere it is literal text.
export const BlogStatus = {
  active: {
    value: PublicationStatusEnum.Active,
    description: 'Active',
    color: 'var(--blog-status-active)',
  },
  inActive: {
    value: PublicationStatusEnum.InActive,
    description: 'In Active',
    color: 'var(--blog-status-inactive)',
  },
  draft: {
    value: PublicationStatusEnum.Draft,
    description: 'Draft',
    color: 'var(--blog-status-draft)',
  },
  internal: {
    value: PublicationStatusEnum.Internal,
    description: 'Internal',
    color: 'var(--blog-status-internal)',
  },
}
